import { FC, useState } from 'react';
import { Button } from 'antd';
import { useTranslation } from 'react-i18next';
import { EyeOutlined } from '@ant-design/icons';
import { useUIDispatchContext } from 'providers/UI';
import dayjs from 'dayjs';
import { fetchReportById } from 'services/api/reports';

import { showRestError } from 'utils/showErrorMessage';

interface IProps {
  id: number | string;
}

const ViewReport: FC<IProps> = ({ id }) => {
  const { t } = useTranslation();
  const { toggleModal } = useUIDispatchContext();
  const [loading, setLoading] = useState(false);

  const onClickViewReport = () => {
    setLoading(true);
    fetchReportById(id)
      .then(res => {
        toggleModal('reportPreview', true, {
          date: res.dateReport ? dayjs(res.dateReport).format() : '',
          aboutDoctor: res.doctorInfo || '',
          report: res.report || '',
          patientBirth: res.dateOfBirth ? dayjs(res.dateOfBirth).format() : '',
          patientName: res.firstName || '',
          patientLastName: res.lastName || '',
          appointmentId: res.appointmentId ? String(res.appointmentId) : '',
          signature: res.signature || '',
          lang: res.lang,
          icd: res.icd
        });
      })
      .catch(err => showRestError(err))
      .finally(() => setLoading(false));
  };

  return (
    <Button
      style={{ minWidth: 135 }}
      loading={loading}
      onClick={onClickViewReport}
      icon={<EyeOutlined />}
    >
      {t('reports.view_report')}
    </Button>
  );
};

export default ViewReport;
